export default class TransferService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  fetchTransfers (query) {
    return new Promise((resolve, reject) => {
      this.$http.post('transfers', query)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  executeTransfer (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('transfers/execute', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
